import { Directive, ElementRef, Input, Host, OnInit, OnDestroy } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { MapService } from '../services/map.service';

@Directive({
  selector: '[appMapOverlay]'
})
export class MapOverlayDirective implements OnInit, OnDestroy {
  info;

  @Input() position: google.maps.LatLngLiteral;
  @Input() onTop = false;
  @Input() filtered = false;
  @Input() wrapperClass = '';
  @Input() panToOpen = false;
  constructor(
    @Host() private readonly _googleMap: GoogleMap,
    private _elementRef: ElementRef<HTMLElement>,
    private mapService: MapService
  ) {}

  ngOnInit() {
    if (this._googleMap._isBrowser) {
      this.info = this.mapService.createInfoWindow({
        map: this._googleMap.googleMap,
        position: this.position,
        closeOnMapClick: false,
        content: this._elementRef.nativeElement,
        showCloseButton: false,
        padding: '3px',
        pointer: '7px',
        maxHeight: 300,
        maxWidth: 400,
        panOnOpen: this.panToOpen,
        wrapperClass: `${this.wrapperClass} ${this.onTop ? 'onTop' : ''} ${this.filtered ? 'filtered' : ''}`,
        whitelistedMouseEvents: [
          'touchstart',
          'touchend',
          'touchmove',
          'drag',
          'dragend',
          'dragstart',
          'wheel',
          'mousewheel',
          'DOMMouseScroll',
          'MozMousePixelScroll'
        ]
      });
      this.info.open();
    }
  }

  ngOnDestroy() {
    this.info.close();
  }
}
